/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {SetInitialCameraLayoutPresetRequest} from "../model/set-initial-camera-layout-preset-request";

@Injectable({
    providedIn: "root",
})
export class SimMultiRoomRecordingService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addAnnouncementToSession(sessionId: string, mediaId: string) {
        return super.post<void>(`/api/MultiRoomRecording/AddAnnouncementToSession/${encodeURIComponent(sessionId)}/audio/${encodeURIComponent(mediaId)}/add`, {});
    }

    public pinAnnouncementInSession(sessionId: string, mediaId: string) {
        return super.post<void>(`/api/MultiRoomRecording/PinAnnouncementInSession/${encodeURIComponent(sessionId)}/audio/${encodeURIComponent(mediaId)}/pin`, {});
    }

    public playAnnouncementInSession(sessionId: string, mediaId: string) {
        return super.post<void>(`/api/MultiRoomRecording/PlayAnnouncementInSession/${encodeURIComponent(sessionId)}/audio/${encodeURIComponent(mediaId)}/play`, {});
    }

    public removeAnnouncementFromSession(sessionId: string, mediaId: string) {
        return super.post<void>(`/api/MultiRoomRecording/RemoveAnnouncementFromSession/${encodeURIComponent(sessionId)}/audio/${encodeURIComponent(mediaId)}/remove`, {});
    }
/**
 * Set the initial camera layout preset for all upcoming recordings in the session
 */ 

    public setInitialCameraLayoutPreset(sessionId: string, stationCameraLayoutPreset: SetInitialCameraLayoutPresetRequest) {
        return super.post<void>(`/api/MultiRoomRecording/SetInitialCameraLayoutPreset/${encodeURIComponent(sessionId)}`, stationCameraLayoutPreset);
    }

    public stopAnnouncementInSession(sessionId: string, mediaId: string) {
        return super.post<void>(`/api/MultiRoomRecording/StopAnnouncementInSession/${encodeURIComponent(sessionId)}/audio/${encodeURIComponent(mediaId)}/stop`, {});
    }

    public transitionToNextPhase(sessionId: string) {
        return super.post<void>(`/api/MultiRoomRecording/TransitionToNextPhase/${encodeURIComponent(sessionId)}/transition`, {});
    }

    public unpinAnnouncementInSession(sessionId: string, mediaId: string) {
        return super.post<void>(`/api/MultiRoomRecording/UnpinAnnouncementInSession/${encodeURIComponent(sessionId)}/audio/${encodeURIComponent(mediaId)}/unpin`, {});
    }
}